import { SignaturesConstants } from '../store/signatures.constants'
import { ISignatureChips, ISignatureTypeOption, ISignatureTypeOptions } from '../store/signatures.types'

/**
 * Determines the next signature section to which the user should be taken.
 * Only applies to section three signature types ("crew" and "receiving") which must be submitted in tandem.
 */
export const determineNextSignatureSection = (
  selectedSignatureType: ISignatureTypeOption | null,
  chips: ISignatureChips,
  signatureTypeOptions: ISignatureTypeOptions,
  conditionObj: any = {}
): ISignatureTypeOption | null => {
  const isCrew = selectedSignatureType?.signatureType === SignaturesConstants.CREW
  const isReceiving = selectedSignatureType?.signatureType === SignaturesConstants.RECEIVING
  const isPatient = selectedSignatureType?.signatureType === SignaturesConstants.PATIENT
  const crewFilled = chips.some((chip) => {
    return chip?.option?.signatureType === SignaturesConstants.CREW
  })
  const receivingFilled = chips.some((chip) => {
    return chip?.option?.signatureType === SignaturesConstants.RECEIVING
  })

  const witnessFilled = chips.some((chip) => {
    return chip?.option?.signatureType === SignaturesConstants.WITNESS
  })

  const crewOption = signatureTypeOptions.find((option) => option.signatureType === SignaturesConstants.CREW)
  const receivingOption = signatureTypeOptions.find((option) => option.signatureType === SignaturesConstants.RECEIVING)
  const witnessOption = signatureTypeOptions.find((option) => option.signatureType === SignaturesConstants.WITNESS)

  if (isCrew && !receivingFilled && receivingOption) {
    return receivingOption
  } else if (isReceiving && !crewFilled && crewOption) {
    return crewOption
  } else if (witnessOption && isPatient && conditionObj.isMark && !witnessFilled) {
    return witnessOption
  } else {
    return null
  }
}
